import Form from 'antd/es/form/index'
import { AccountInternalRole } from '../../../../enums/management-input.enum.ts'
import Input from 'antd/es/input'
import Select from 'antd/es/select/index'
import { FormInstance } from 'antd/lib/index'
import { UserManagementFormFieldTypes } from './user-management-form.tsx'
import { UserManagementNormalForm } from './user-management-normal-form.tsx'
import { useTranslation } from 'react-i18next'

interface UserManagementInternalFormProps {
  form: FormInstance<UserManagementFormFieldTypes>
}

export const UserManagementInternalForm: React.FC<
  UserManagementInternalFormProps
> = ({ form }) => {
  const { t } = useTranslation()
  const internalRoleOptions = [
    {
      value: AccountInternalRole.Admin,
      label: AccountInternalRole.Admin,
    },
    {
      value: AccountInternalRole.Normal,
      label: AccountInternalRole.Normal,
    },
    {
      value: AccountInternalRole.SuperViewer,
      label: AccountInternalRole.SuperViewer,
    },
  ]
  return (
    <>
      <Form.Item
        label={t('user_management.user_modal.form.full_name')}
        name={'fullName'}
        rules={[
          {
            required: true,
            message: t(
              'user_management.user_modal.form.please_input_full_name'
            ),
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label={t('user_management.user_modal.form.email')}
        name={'email'}
        rules={[
          {
            required: true,
            message: t('user_management.user_modal.form.please_input_email'),
          },
          {
            type: 'email',
            message: t(
              'user_management.user_modal.form.please_enter_valid_email'
            ),
          },
          {
            validator: (_, value) => {
              if (
                !value ||
                value.endsWith('@polymercapital.com') ||
                value.endsWith('@pag.com')
              ) {
                return Promise.resolve()
              }
              return Promise.reject(
                new Error(
                  t(
                    'user_management.user_modal.form.email_internal_domain_error'
                  )
                )
              )
            },
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label={t('user_management.user_modal.form.internal_role')}
        name={'internalRole'}
        rules={[
          {
            required: true,
            message: t(
              'user_management.user_modal.form.please_select_internal_role'
            ),
          },
        ]}
      >
        <Select
          placeholder={t(
            'user_management.user_modal.form.select_internal_role'
          )}
          options={internalRoleOptions}
        />
      </Form.Item>
      <UserManagementNormalForm form={form} />
    </>
  )
}
